module.exports = __webpack_public_path__ + "static/media/arrowUp.7a62707f.svg";